// AUTHOR: GOPALAKRISHNAN
// VERSION: 0.0.1
// LAST EDIT: GOPALAKRISHNAN
// DATE: 05/01/2026
// DESCRIPTION: DEALER REPORT PAGE ACTION
import DealerReportActionTypes from './dealer-report.types';

/** ***************** FETCH DEALER REPORT DETAILS START *********************** */
export const fetchDealerReportStart = (getData: any) => ({
	type: DealerReportActionTypes.FETCH_DEALER_REPORT_START,
	payload: getData,
});

export const fetchDealerReportSuccess = (successData: any) => ({
	type: DealerReportActionTypes.FETCH_DEALER_REPORT_SUCCESS,
	payload: successData,
});

export const fetchDealerReportFailure = (failureData: any) => ({
	type: DealerReportActionTypes.FETCH_DEALER_REPORT_FAILURE,
	payload: failureData,
});

export const fetchDealerReportResponseReset = () => ({
	type: DealerReportActionTypes.FETCH_DEALER_REPORT_RESPONSE_RESET,
});

export const fetchDealerReportResponseChanged = () => ({
	type: DealerReportActionTypes.FETCH_DEALER_REPORT_RESPONSE_CHANGED,
});
/** ***************** FETCH DEALER REPORT DETAILS START *********************** */
